import React, { useEffect, useState } from "react";
import { Breadcrumb, Row, Col, Typography, Button, Tabs } from "antd";
import { Link, useHistory, useParams } from "react-router-dom";
import Categories from "./Categories/index";
import AllProducts from "./AllProducts/index";
import API_KEY from "../../../api";
import { gaEvent } from "../../../analytics/analytics";
import * as GA from "../../../constants/analytics";
import Can from "../../../casl/Can";
import { PERMISSIONS } from "constants/permissions";
import { useGlobal } from "store/index";
const { Title, Text } = Typography;
const { TabPane } = Tabs;
export default function MasterCatalogue() {
  const history = useHistory();

  const params = useParams();
  const [Count, setCount] = useState();
  const [selectTab, setSelectTab] = useState(1);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [globalState, globalActions] = useGlobal();
  const { permissions } = globalState;
  const key = params?.key ? params?.key:"1";
  var userId = localStorage.getItem("userId");
  var isAdmin = localStorage.getItem("isAdmin");
  var userFilter = "";

  function callback(key) {
    console.log(key);
    setSelectTab(key);
  }

  console.log("key--",key);
  const openCategoryModal = () => {
    setIsModalVisible((state) => !state);
  };

  if ((permissions?.permissions.length > 0) & (isAdmin === "false")) {
    var check_current_user = permissions?.permissions.filter(
      (el) =>
        (el?.slug === "view_products") &
        el?.subPermission?.values?.includes("current_user")
    );
    if (check_current_user.length > 0) {
      userFilter = { user_id: { _eq: userId } };
    }
  }

  const fetch_count = () => {
    API_KEY.URL.get(API_KEY.path.products, {
      params: {
        meta: "total_count,filter_count",
        limit: 0,
        filter: userFilter,
      },
    })
      .then((res) => {
        setCount(res?.data?.meta?.filter_count);
      })
      .catch((error) => console.log(error));
  };
  useEffect(() => {
    if (permissions) {
      fetch_count();
    }
  }, [permissions]);

  const operations = 
    
      <div>
          <Can
            I={PERMISSIONS.create_products.slug}
            a={PERMISSIONS.create_products.permissionType}
          >
            {(allowed) => (
              <div>
                <Button
                  onClick={() => {
                    history.push("/add-product");
                    gaEvent(
                      GA.EVENT.CLICK,
                      GA.CATEGORY.ADD_PRODUCT,
                      GA.DESCRIPTION.ADD_PRODUCT_BUTTON
                    );
                  }}
                  //type="primary"
                  size="large"
                  style={{
                    height: "2.5em",
                    fontSize: "16px",
                    float: "left",
                    background:"#F0F8F6",
                    color:"#0B7764",
                    border: "1px solid #6DADA2",
                    marginRight:"1em",
                    fontWeight:"normal"
                   // width: "48%",
                  }}
                >
                  Add product
                </Button>

                {/* <Button
                    type="primary"
                    onClick={() => {
                      //openCategoryModal();
                      gaEvent(
                        GA.EVENT.CLICK,
                        GA.CATEGORY.ADD_PRODUCT,
                        GA.DESCRIPTION.ADD_PRODUCT_BUTTON
                      );
                    }}
                    size="large"
                    style={{
                      height: "2.5em",
                      fontSize: "16px",
                      //background: "#363E3D",
                      //color: "white",
                      float: "right",
                      fontWeight:"normal"
                     // width: "48%",
                    }}
                  >
                    Manage Products
                  </Button> */}
              </div>
            )}
          </Can>
      </div>
       
      
  
    
  
  
  return (
    <div>
      <Row>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link
              to="/"
              onClick={() => {
                gaEvent(
                  GA.EVENT.CLICK,
                  GA.CATEGORY.RETURN,
                  GA.DESCRIPTION.RETURN_TO_HOME
                );
              }}
            >
              {" "}
              Home
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>All Products</Breadcrumb.Item>
        </Breadcrumb>
      </Row>
    
      {/* <Row justify="space-between" style={{ marginTop: "1rem" }}>
        <Col span={16}>
          <Title level={2} style={{ fontFamily: "Gilroy" }}>
            All Products
          </Title>
        </Col>
        <Col span={8}>
         
          <Can
            I={PERMISSIONS.create_products.slug}
            a={PERMISSIONS.create_products.permissionType}
          >
            {(allowed) => (
              <div>
                {selectTab == 2 ? (
                  <Button
                    onClick={() => {
                      openCategoryModal();
                      gaEvent(
                        GA.EVENT.CLICK,
                        GA.CATEGORY.ADD_PRODUCT,
                        GA.DESCRIPTION.ADD_PRODUCT_BUTTON
                      );
                    }}
                    size="large"
                    style={{
                      height: "3rem",
                      fontSize: "18px",
                      background: "#363E3D",
                      color: "white",
                      float: "left",
                      width: "48%",
                    }}
                  >
                    Add Category
                  </Button>
                ) : null}

                <Button
                  onClick={() => {
                    history.push("/add-product");
                    gaEvent(
                      GA.EVENT.CLICK,
                      GA.CATEGORY.ADD_PRODUCT,
                      GA.DESCRIPTION.ADD_PRODUCT_BUTTON
                    );
                  }}
                  type="primary"
                  size="large"
                  style={{
                    height: "3rem",
                    fontSize: "18px",
                    float: "right",
                    width: "48%",
                  }}
                >
                  Add products
                </Button>
              </div>
            )}
          </Can>
        
        </Col>
      </Row>
      {Count ? (
        <Row>
          <Text type="secondary" style={{ marginTop: -10 }}>
            {Count} products
          </Text>
        </Row>
      ) : (
        ""
      )} */}

      <Row style={{ marginTop: "1rem" }}>
        <Col span={24}>
          <Tabs defaultActiveKey={key} size="large" onChange={callback} tabBarExtraContent={operations}>
            <TabPane
              tab={
                <span
                  style={{ fontSize: 20, fontWeight:"bold" }}
                  onClick={() => {
                    gaEvent(
                      GA.EVENT.CLICK,
                      GA.CATEGORY.MASTER_CATALOGUE,
                      GA.DESCRIPTION.ALL_PRODUCTS
                    );
                  }}
                >
                  All Products
                </span>
              }
              key="1"
            >
              <AllProducts />
            </TabPane>
            <TabPane
              tab={
                <span
                  style={{ fontSize: 20, fontWeight:"bold" }}
                  onClick={() => {
                    gaEvent(
                      GA.EVENT.CLICK,
                      GA.CATEGORY.MASTER_CATALOGUE,
                      GA.DESCRIPTION.CATEGORIES
                    );
                  }}
                >
                  Categories
                </span>
              }
              key="2"
            >
              <Categories
                isModalVisible={isModalVisible}
                setIsModalVisible={setIsModalVisible}
              />
            </TabPane>
          </Tabs>
        </Col>

        
      </Row>
    </div>
  );
}
